let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jpIhK")).then(() => parcelRequire('26KKg'));